import { toNameConfigMapping } from '../../../configFields';
import { AuthStep } from './AuthStep';
import { BinaryPoll } from './BinaryPoll';
import { CardSortingCategoryPoll } from './CardSortingCategoryPoll';
import { ChoiceConjoint } from './ChoiceConjoint';
import { ClickMapPoll } from './ClickMapPoll';
import { FilePoll } from './FilePoll';
import { MarkupAreaPoll } from './MarkupAreaPoll';
import { MatrixMultiplePoll } from './MatrixMultiplePoll';
import { MatrixRatingDigitsPoll } from './MatrixRatingDigitsPoll';
import { MatrixRatingStarsPoll } from './MatrixRatingStarsPoll';
import { MatrixSinglePoll } from './MatrixSinglePoll';
import { MaxDiffPoll } from './MaxDiffPoll';
import { MediaFileAny } from './MediaFileAny';
import { MediaFileAudio } from './MediaFileAudio';
import { MediaFileImage } from './MediaFileImage';
import { MediaFileLink } from './MediaFileLink';
import { MediaFileText } from './MediaFileText';
import { MediaFileVideo } from './MediaFileVideo';
import { MultipleFromPicturePoll } from './MultipleFromPicturePoll';
import { MultiplePoll } from './MultiplePoll';
import { MultipleSelectPoll } from './MultipleSelectPoll';
import { PrototypeScreen } from './PrototypeScreen';
import { RankPoll } from './RankPoll';
import { RatingDigitsPoll } from './RatingDigitsPoll';
import { RatingLikePoll } from './RatingLikePoll';
import { RatingSliderPoll } from './RatingSliderPoll';
import { RatingSmiliesPoll } from './RatingSmiliesPoll';
import { RatingStarsPoll } from './RatingStarsPoll';
import { SelectAreaPoll } from './SelectAreaPoll';
import { SelectPoll } from './SelectPoll';
import { SingleFromPicturePoll } from './SingleFromPicturePoll';
import { SinglePoll } from './SinglePoll';
import { SwitchPoll } from './SwitchPoll';
import { TextareaPoll } from './TextareaPoll';

export const Questions = {
  PrototypeScreen,
  SinglePoll,
  MaxDiffPoll,
  ChoiceConjoint,
  MultiplePoll,
  SingleFromPicturePoll,
  MultipleFromPicturePoll,
  RankPoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  TextareaPoll,
  SelectPoll,
  MultipleSelectPoll,
  MatrixSinglePoll,
  MatrixMultiplePoll,
  MatrixRatingDigitsPoll,
  MatrixRatingStarsPoll,
  ClickMapPoll,
  MarkupAreaPoll,
  SelectAreaPoll,
  FilePoll,
  MediaFileAny,
  MediaFileImage,
  MediaFileAudio,
  MediaFileVideo,
  MediaFileText,
  MediaFileLink,
  AuthStep,
  CardSortingCategoryPoll,
  SwitchPoll,
  BinaryPoll,
};

export const questionsList = [
  PrototypeScreen,
  SinglePoll,
  MaxDiffPoll,
  ChoiceConjoint,
  MultiplePoll,
  SingleFromPicturePoll,
  MultipleFromPicturePoll,
  RankPoll,
  RatingDigitsPoll,
  RatingLikePoll,
  RatingSliderPoll,
  RatingSmiliesPoll,
  RatingStarsPoll,
  TextareaPoll,
  SelectPoll,
  MultipleSelectPoll,
  MatrixSinglePoll,
  MatrixMultiplePoll,
  MatrixRatingDigitsPoll,
  MatrixRatingStarsPoll,
  ClickMapPoll,
  MarkupAreaPoll,
  SelectAreaPoll,
  FilePoll,
  MediaFileAny,
  MediaFileImage,
  MediaFileAudio,
  MediaFileVideo,
  MediaFileText,
  MediaFileLink,
  AuthStep,
  CardSortingCategoryPoll,
  SwitchPoll,
  BinaryPoll,
] as const;

export const questionsMapping = toNameConfigMapping(questionsList);
